<template>
  <div id="xrp_waterfall_container">
    <XRPWaterfall />
  </div>
</template>

<script>
export default {
  name: 'Waterfall'
}
</script>

<style scoped>
#xrp_waterfall_container{
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
